import { z } from "zod";
import { PayStandCardSchema } from "./pay-stand-card";
import { PayStandBankSchema } from "./pay-stand-bank";

export const PayStandPaymentTokenSchema = z.object({
  object: z.string(),
  id: z.string(),
  used: z.boolean(),
  reusable: z.boolean(),
  cardId: z.string().optional(),
  bankId: z.string().optional(),
  card: PayStandCardSchema.optional(),
  bank: PayStandBankSchema.optional(),
  payerId: z.string(),
  created: z.string(),
  lastUpdated: z.string(),
  status: z.string(),
});

export type PayStandPaymentTokenType = z.infer<
  typeof PayStandPaymentTokenSchema
>;
